import storage from 'redux-persist/lib/storage';
import { apiPath } from './api.path';
import { instance } from './axios';
import { persistor } from '../redux/store';

async function loginAPI(params) {
  return instance.post(apiPath.login, params).then((response) => {
    console.log(response.data.data);
    localStorage.setItem('user_token', JSON.stringify(response.data.data));
    if (response.data.token) {
      localStorage.setItem('user', JSON.stringify(response.data.data));
    }
    return response.data;
  });
}

async function forgotPasswordAPI(params) {
  return instance.post(apiPath.forgotPassword, params).then((response) => response.data);
}

async function profileAPI() {
  return instance.get(apiPath.profile).then((response) => response.data);
}

async function updateProfileAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('_id', params._id);
  bodyFormData.append('email', params.email);
  bodyFormData.append('fullName', params.fullName);
  bodyFormData.append('image', params.photoURL.file);

  return instance.post(apiPath.updateProfile, bodyFormData).then((response) => response.data);
}

async function verifyEmailAPI(params) {
  return instance.post(apiPath.verifyEmail, params).then((response) => response.data);
}

async function changePasswordAPI(params) {
  return instance.post(apiPath.changePassword, params).then((response) => {
    console.log(response);
    return response.data;
  });
}

async function logoutAPI() {
  storage.removeItem('persist:root');
  setTimeout(() => persistor.purge(), 200);
}

const authService = {
  loginAPI,
  forgotPasswordAPI,
  profileAPI,
  updateProfileAPI,
  logoutAPI,
  verifyEmailAPI,
  changePasswordAPI
};
export default authService;
